import { render, staticRenderFns } from "./add-keys.vue?vue&type=template&id=7d53fd30&scoped=true&"
import script from "./add-keys.ts?vue&type=script&lang=ts&"
export * from "./add-keys.ts?vue&type=script&lang=ts&"
import style0 from "./add-keys.scss?vue&type=style&index=0&id=7d53fd30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d53fd30",
  null
  
)

export default component.exports